import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { ZeroOneThemeProvider } from '@01_people/ui-library';
import { generateTheme } from '../../../utils/colors';
import MyGlobals from '../../../assets/styles/globals.styled';

function ConnectedThemeProvider({ children }) {
  const serverTheme = useSelector(state => state.ui.theme);
  return (
    <ZeroOneThemeProvider
      theme={generateTheme(serverTheme)}
      globals={MyGlobals}
    >
      {children}
    </ZeroOneThemeProvider>
  );
}

ConnectedThemeProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default ConnectedThemeProvider;
